import script from "./ProjectUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectUsers.vue?vue&type=script&setup=true&lang=js"

import "./ProjectUsers.vue?vue&type=style&index=0&id=66138350&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66138350"]])

export default __exports__